import React, { useEffect } from 'react';

export default function GalleryModal({ images, currentIndex, onClose, onPrev, onNext }) {
  const isOpen = currentIndex !== null && images && images.length > 0;

  // Handle keyboard events and lock body scroll only when modal is actively open
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    
    // Prevent background scrolling when modal is open
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = originalOverflow || '';
    };
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen) return null;

  const currentImageUrl = images[currentIndex];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md p-4">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors focus:outline-none"
        aria-label="Luk galleri"
      >
        <i className="fa-light fa-xmark text-2xl" />
      </button>

      {/* Navigation - Left */}
      <button
        onClick={onPrev}
        className="absolute left-4 md:left-8 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors focus:outline-none active:scale-95"
        aria-label="Forrige billede"
      >
        <i className="fa-light fa-chevron-left text-xl" />
      </button>

      {/* Main Image Container */}
      <div className="relative max-h-[85vh] max-w-[90vw] flex flex-col items-center justify-center select-none">
        <img
          src={currentImageUrl}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-h-[80vh] max-w-full rounded-none object-contain shadow-2xl"
          draggable={false}
        />
        {/* Image Counter */}
        <div className="mt-4 text-sm text-white/60 font-medium">
          {currentIndex + 1} / {images.length}
        </div>
      </div>

      {/* Navigation - Right */}
      <button
        onClick={onNext}
        className="absolute right-4 md:right-8 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors focus:outline-none active:scale-95"
        aria-label="Næste billede"
      >
        <i className="fa-light fa-chevron-right text-xl" />
      </button>

      {/* Click outside to close */}
      <div className="absolute inset-0 -z-10" onClick={onClose} />
    </div>
  );
}
